module.exports = __webpack_public_path__ + "static/media/relaxation_techniques.6e2537d3.svg";